import { computedFrom } from 'aurelia-binding';
import { HttpClient } from 'aurelia-fetch-client';
import { autoinject } from 'aurelia-framework';
import 'whatwg-fetch';
import { ApiResponse } from '../models/api-response';
import { ServiceResponse } from '../models/service-response';
import { State } from './global-state';
import { HPFServiceClient } from './hpfApi';

@autoinject
export class HpfCarouselService extends HPFServiceClient {

	constructor(
		state: State,
		http: HttpClient,
	) {
		super(state, http);
	}

	getCarousel(portalId: string) {
		let url = `/portal/${portalId}/carousel`;
		return this.get(url).then(
			(response) => {
				let result = {
					interval: 6,
					items: []
				};
				if (response.isSuccessful) {
					result.items = response.value.carouselItems || [];
					result.interval = response.value.interval || 6;
				}
				return result;
			},
			(error) => {
				return {
					interval: 6,
					items: []
				};
			}
			);
	}
}
